import { render } from "./LoginPINView.vue?vue&type=template&id=08d561fb"
import script from "./LoginPINView.vue?vue&type=script&lang=js"
export * from "./LoginPINView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__